import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getContacts } from "../../../store/actions"
import { Container, Row, Col, Card, CardBody, Offcanvas, OffcanvasHeader, OffcanvasBody, Label, FormGroup, CardHeader, Accordion, AccordionItem, AccordionHeader, AccordionBody } from "reactstrap"
import FilterMenuContact from "../filter-menu/filter-menu"
import Moment from 'react-moment';
import RsAdNew from "components/buttons/Adnew";
import dragImg from "../../../assets/img/drag-and-drop.png"
import styled from 'styled-components';
import Board from 'react-trello'
import { API_URL } from "helpers/app_url";
import axios from "axios";
const laneColors = ['#FF9999', '#99FF99', '#9999FF', '#FFFF99', '#FF99FF', '#99FFFF'];
const StyledBoard = styled(Board)`
  padding: 20px;
  
  .react-trello-lane:nth-child(1) header{
    //background-color: #0D6EFD;
    border-bottom:3px solid #0D6EFD !important;
    border:1px solid #ccc;
    //text-align:left;
    color:#000;
  }
  .react-trello-lane:nth-child(2) header{
    //background-color: rgb(255, 222, 89);
     border-bottom:3px solid #198754 !important;
      border:1px solid #ccc;
    //text-align:center;
    color:#000;
  }
   .react-trello-lane:nth-child(3) header{
    //background-color: rgb(92, 225, 230);
    border-bottom:3px solid #0DCAF0 !important;
    border:1px solid #ccc;
    //text-align:center;
    color:#000;
  }
  .react-trello-lane:nth-child(4) header{
    //background-color: rgb(126, 217, 87);
    border-bottom:3px solid #AB2E3C !important;
    border:1px solid #ccc;
    //text-align:center;
    color:#000;
  }
  .react-trello-lane:nth-child(5) header{
    //background-color: rgb(255, 189, 89);
   border-bottom:3px solid #FFC107 !important;
   border:1px solid #ccc;
    //text-align:center;
    color:#000;
  }

  .react-trello-lane header{
    //background-color: rgb(0, 0, 0);
    //text-align:center;
    border-bottom:3px solid #000 !important;
    border:1px solid #ccc;
    color:#000;
    padding: 10px 1.25rem !important;
    background-color:#fff;
  }
  .react-trello-lane{ background-color:#f8f8f8 !important; padding: 10px 5px !important; padding-top:0px !important; }
  .CIzYb{ font-size:16px; padding-left: 1.25rem; text-transform: uppercase;}
`;
const CustomCard = ({ onClick, title, description, metadata  }) => {
 
  return (
    <Card className="mb-3 custom-card" onClick={onClick}>
      <CardBody>
      <div className="float-end ms-2"><span className="badge rounded-pill badge-soft-success font-size-12">{metadata.contactClassificationId}</span></div>
      <div className="d-flex align-items-center">
        <h5 className="card-title mb-2 lead-box-title width-100"><Link to="#">{title}</Link> </h5>
      </div>
      
    <div className="row pt-1 align-items-center">
      <div className="col">
        <i className="bx bx-calendar align-middle"></i> {metadata.lastContact}
      </div>
      <div className="col-auto ms-auto">
        <Link to={`/contact/contact-detail/${metadata.id}/${metadata.link}`}>
          <i className="bx bx-link-external font-size-20 align-middle"></i>
        </Link>
      </div>
    </div>
      </CardBody>
    </Card>
  );
};

CustomCard.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  metadata: PropTypes.shape({
    mobile: PropTypes.string,
    email: PropTypes.string,
    id:PropTypes.number,
    lastContact:PropTypes.string,
    contactClassificationId:PropTypes.string,
    link:PropTypes.string
  }),

};
// Custom Lane component

const LaneHeader = styled.div`
  background-color: ${props => props.color} !important;
  color: white !important;
  padding: 10px !important;
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
  font-weight: bold !important;
`;
const LaneBody = styled.div`
  background-color: #f8f9fa;
  padding: 10px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;
const getLaneColor = (index) => {
  const colors = ['#007bff', '#28a745', '#ffc107', '#dc3545', '#17a2b8', '#6610f2'];
  return colors[index % colors.length];
};

const CustomLane = ({ index, title, children }) => {
  const color = getLaneColor(index);
  return (
    <div>
      <LaneHeader color={color}>{title}</LaneHeader>
      <LaneBody>{children}</LaneBody>
    </div>
  );
};

// const CustomLanes = ({ index, title, children }) => {
//   const color = getLaneColor(index);
//   return (
//     <div style={{ backgroundColor: '#f8f9fa' }}>
//       <div style={{ backgroundColor: color }}>
//         {title}
//       </div>
//       {children}
//     </div>
//   );
// };
CustomLane.propTypes = {
  index: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
class ConnectFrequency extends Component {
  constructor(props) {
    super(props)
    this.state = {
     
    }
   
  }
  
 componentDidMount() {
    const { onGetAllContact } = this.props;
    onGetAllContact(localStorage.getItem('userId'));
  }

 getClassification = (contactClassificationId) => {
    switch (contactClassificationId) {
      case 2:
        return "Gold";
      case 1:
        return "Silver";
      case 3:
        return "VIP";
       case 4:
        return "Investor";
       case 5:
        return "Vendors";
      default:
        return "-";
    }
  };


 onCardMoveAcrossLanes = (fromLaneId, toLaneId, cardId, index) => {
    const pastData = {
      id: cardId,
      oldContactFrequency: fromLaneId,
      newContactFrequency: toLaneId,
      agentId: parseInt(localStorage.getItem('userId'))
    };
    const obj = JSON.parse(localStorage.getItem("authUser"));
          const token = obj?.resultData?.bearerToken;
          const url = `${API_URL}Contact/quickUpdateContactFrequency`;
          toast.loading("Please wait...");
          axios
            .post(url, pastData, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              if (response.data.success) {
                toast.dismiss();
                toast.success("Frequency updated successfully!");
                resetForm();
                
              } else {
                toast.dismiss();
                toast.error('some issue while updating frequency');
                console.warn("Submission failed:", response.data);
              }
            })
            .catch((error) => {
              console.error("Error sending message:", error);
      
            });
    
  };

  render() {
     const { contacts, gridLoading, isResponsive } = this.props;
        const contactClassificationList = [
              { id: 0, value: '', name: 'Un Assigned' },
              { id: 1, value: 'Monthly',name: 'Monthly' },
              { id: 2, value: 'Quarterly',name: 'Quarterly' },
              { id: 3, value: 'Semi-annual',name: 'Semi-annual' },
              { id: 4, value: 'Annual',name: 'Annual' },
             
            ];
        
   const data = {
  lanes: contactClassificationList.map(stage => ({
    id: stage.value,
    title: stage.name,
    cards: contacts
      .filter(contact => {
        if (stage.value === '') {
          return contact.connectFrequency === '' || contact.connectFrequency === null;
        }
        return contact.connectFrequency === stage.value;
      })
      .map(contact => ({
        id: contact.id,
        title: `${contact.firstName} ${contact.lastName}`,
        draggable: true,
        label: '',
        metadata: {
          mobile: contact.mobile,
          email: contact.email,
          contactClassificationId:this.getClassification(contact.contactClassificationId),
          lastContact: (contact.lastContact) ? <Moment format="D MMM YY">{contact.lastContact}</Moment> : '-',
          id: contact.id,
          link: contact.contactId,
        }
      }))
  }))
};

  const brColor = [{borderBottom:'3px solid #0D6EFD'},{borderBottom:'3px solid #198754'},{borderBottom:'3px solid #0DCAF0'}, {borderBottom:'3px solid #AB2E3C'},{borderBottom:'3px solid #FFC107'}];
  
  
  

   const allLocal = localStorage.getItem('localData')
   const localization = JSON.parse(allLocal);
   const renderMobileAccordion = () => {
          
         return (
           <Card>
             <CardBody>
                <Accordion
             open={this.state.openLane}
             toggle={(id) =>
               this.setState({ openLane: this.state.openLane === id ? null : id })
             }
           >
             {data.lanes.map((lane) => (
               <AccordionItem key={lane.id}>
                 <AccordionHeader targetId={lane.id}>{lane.title}</AccordionHeader>
                 <AccordionBody accordionId={lane.id}>
                   {lane.cards.map((card) => (
                     <CustomCard
                       key={card.id}
                       {...card}
                      
                     />
                   ))}
                 </AccordionBody>
               </AccordionItem>
             ))}
           </Accordion>
             </CardBody>
           </Card>
          
         );
       };
    return (
      <React.Fragment>
         {gridLoading ? (
          <div className="rs-loader-overlay">
            <div className="rs-loader"></div>
          </div>
        ) : null}
         <ToastContainer autoClose={2000} />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Engagement View | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0 pe-0">
            {/* <Row className="project-header">
              <Col xl="7">
                <Breadcrumbs
                  title={this.props.t("Lead")}
                  breadcrumbItem={this.props.t("Engagement View")}
                />
              </Col>
              <Col xl="5">
               <div className="pt-2 float-end mt-2">
                                 <RsAdNew to="/contact/import-contact" className="btn btn-light btn-md me-2" iconClass="bx bx-download">Import Contact</RsAdNew>
                                 <RsAdNew to="#" onClick={this.toggleAddNew} className="btn btn-light btn-md" iconClass="bx bx-plus-medical">Add New</RsAdNew>
                               </div>
              </Col>
            </Row> */}
              <Card className="card-without-border">
              <CardHeader className="">
             <FilterMenuContact />
             </CardHeader>
             </Card>
            <Row>
                  <Col sm="12">
                    <Card>
                   
                    </Card>
                    {isResponsive ? renderMobileAccordion():(
                        <StyledBoard 
                    style={{backgroundColor: 'white'}}
                    data={data} 
                    onCardMoveAcrossLanes={this.onCardMoveAcrossLanes}
                    draggable
                    laneDraggable={false}
                    cardDraggable
                    components={{ 
                      Card: props => <CustomCard {...props} />,
                      Lane: CustomLane
                    }}
                  />
                    )}
                   
                  </Col>
                </Row>  
          </Container>
        
        </div>
      </React.Fragment>
    )
  }
}
ConnectFrequency.propTypes = {
  t: PropTypes.any,
  onGetAllContact:PropTypes.func,
  contacts: PropTypes.array,
  gridLoading: PropTypes.object,
  isResponsive:PropTypes.object
}
const mapStateToProps = ({  contact }) => (
  {
    gridLoading: contact.gridLoading,
    contacts: contact.contacts,
  })
const mapDispatchToProps = dispatch => ({
     onGetAllContact: (agentId) => dispatch(getContacts(agentId)),
});
export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(ConnectFrequency))
